import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "add-quotation-modal-body" }
const _hoisted_2 = { class: "modal-bar" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = { class: "actions" }

import { computed, ref } from "vue";
import AppTextField from "@/shared/components/ui/AppTextField.vue";
	import AppTextArea from "@/shared/components/ui/AppTextArea.vue";
	import { useModalStore } from "@/shared/stores/modal";
  import { useSnackbarStore } from "@/shared/stores/snackbar";
	import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
  import {
    deleteQuotationTemplateSection,
    saveQuotationTemplateSections,
  } from "@/modules/vendor/services/quotation-templates.api";

		export type QuotationSectionInput = {
		  title: string;
		  description: string;
		};

		
export default /*@__PURE__*/_defineComponent({
  __name: 'AddQuotationSectionModal',
  props: {
    templateId: {},
    sectionId: {},
    mode: {},
    initial: {},
    onAdd: { type: Function },
    onSave: { type: Function },
    onDeleted: { type: Function }
  },
  setup(__props: any) {

const props = __props;

	const modal = useModalStore();
  const snackbar = useSnackbarStore();

		const name = ref(props.initial?.title ?? "");
		const description = ref(props.initial?.description ?? "");
    const isSubmitting = ref(false);
    const isDeleting = ref(false);

    const isNameValid = computed(() => Boolean(name.value.trim()));

	async function handleSubmit() {
	  if (!name.value.trim()) return;
    if (isSubmitting.value) return;

    isSubmitting.value = true;

		  const quotationSection: QuotationSectionInput = {
		    title: name.value.trim(),
		    description: description.value.trim(),
		  };

      try {
        const payload: Record<string, any> = {
          id: props.mode === "edit" ? props.sectionId ?? null : null,
          title: quotationSection.title,
          description: quotationSection.description || null,
        };

        await saveQuotationTemplateSections(props.templateId, payload);

		    if (props.mode === "edit") {
		      props.onSave?.(quotationSection);
		    } else {
		      props.onAdd?.(quotationSection);
		    }
		    modal.close();
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Unable to save section.";
        snackbar.error(message);
      } finally {
        isSubmitting.value = false;
      }
		}

    async function handleDelete() {
      if (isSubmitting.value || isDeleting.value) return;
      if (!props.sectionId) return;

      isDeleting.value = true;
      try {
        await deleteQuotationTemplateSection(props.sectionId);
        await props.onDeleted?.();
        modal.close();
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Unable to delete section.";
        snackbar.error(message);
      } finally {
        isDeleting.value = false;
      }
    }

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_toolbar, {
      class: "modal-toolbar",
      density: "comfortable",
      flat: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_btn, {
            icon: "",
            variant: "text",
            class: "back-btn",
            "aria-label": "Back",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modal).close()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("mdi-arrow-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, _toDisplayString(props.mode === "edit" ? "Edit section" : "Add section"), 1)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_card_text, { class: "body py-6" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_form, {
          class: "form",
          onSubmit: _withModifiers(handleSubmit, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(AppTextField, {
              modelValue: name.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((name).value = $event)),
              label: "Section name",
              placeholder: "e.g. Services"
            }, null, 8, ["modelValue"]),
            _createVNode(AppTextArea, {
              modelValue: description.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((description).value = $event)),
              label: "Description",
              placeholder: "Enter section details...",
              rows: "4"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(AppButtonFlat, {
                block: "",
                class: "mb-4",
                type: "submit",
                "prepend-icon": "mdi-check",
                loading: isSubmitting.value,
                disabled: isSubmitting.value || isDeleting.value || !isNameValid.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.mode === "edit" ? "Save" : "Add"), 1)
                ]),
                _: 1
              }, 8, ["loading", "disabled"]),
              (props.mode === 'edit')
                ? (_openBlock(), _createBlock(AppButtonFlat, {
                    key: 0,
                    block: "",
                    type: "button",
                    "prepend-icon": "mdi-delete-outline",
                    color: "error",
                    variant: "outlined",
                    loading: isDeleting.value,
                    disabled: isDeleting.value || isSubmitting.value,
                    onClick: handleDelete
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode(" Delete ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading", "disabled"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})